import { Testimonial } from './components/WhatStudentSay/types';
import JaniceAvatar from './images/janine_hernando.jpg';
import VinceAvatar from './images/vince_t.jpg';
import MargaritaAvatar from './images/margarita.jpg';
import VivianAvatar from './images/vivian_ononiwu_aliyu.jpg';

const BASE_TESTIMONIAL_COURSE = {
  paidCohort: false,
  alreadyStarted: true,
  currency: '',
  startDateISO: '',
  hideCost: false,
  courseType: 'SHORT_COURSE',
  studentPrice: 0,
  hideStatus: true,
  showLearners: true,
  clickable: false,
};

export const testimonials: Testimonial[] = [
  {
    name: 'Janine Hernando',
    avatar: JaniceAvatar,
    cohort: 'Transition Program Online – UNSW',
    description:
      '“The UNSW Transition Program has taught me many great things one of them is how to be a self-reflective and independent learner.”',
    course: {
      ...BASE_TESTIMONIAL_COURSE,
      name: 'Academic English',
      image:
        'https://openlearning-cdn.s3.amazonaws.com/course__unswtransitionprogramonline_courses_acade20211__course-promo-image-1613692245.41.jpg',
      institution: 'unsw-transition-program-online',
      courseSummary:
        'Academic English forms a foundation for ALL your other courses. You will learn how to express your thoughts and ideas in a way that conforms to academic standards.',
      students: 165,
      path: 'unsw-transition-program-online/courses/acad-e-2021-1',
      courseUrl:
        'https://www.openlearning.com/unsw-transition-program-online/courses/acad-e-2021-1/',
      creator: {
        'avatar@3x':
          'https://openlearning-cdn.s3.amazonaws.com/unswtransitionprogramonline-qmyabj-avatar-120-ts1610925001.jpg',
        fullName: 'UNSW Transition Program Online',
      },
    },
  },
  {
    name: 'Vince T.',
    avatar: VinceAvatar,
    cohort: 'CS101: Programming and Computational Thinking',
    description:
      '“CS101 has been a great experience so far. I love the social, collaborative approach to learning which encourages you to interact with other learners in a natural and organic manner.”',
    course: {
      ...BASE_TESTIMONIAL_COURSE,
      name: 'CS101: Programming and Computational Thinking',
      image:
        'https://openlearning-cdn.s3.amazonaws.com/course__cs101_courses_programming__course-promo-image-1627867594.66.jpg',
      institution: 'cs101',
      courseSummary:
        'Develop your computational thinking and problem solving skills from the ground up, learn the art and science of programming to write beautiful code.',
      students: 89,
      path: 'cs101/courses/programming',
      courseUrl: 'https://www.openlearning.com/cs101/courses/programming/',
      creator: {
        'avatar@3x':
          'https://openlearning-cdn.s3.amazonaws.com/david.collien-avatar-120-ts1497968501.jpg',
        fullName: 'David Collien',
      },
    },
  },
  {
    name: 'Margarita',
    avatar: MargaritaAvatar,
    cohort: 'UNSW AI',
    description:
      '“Using the OpenLearning platform has kept me motivated to complete the course early through clearly segmented topic sections, as well as track my progress easily. On a personal level, online learning was a great way to keep my brain active and talk about something new with my peers.”',
    course: {
      ...BASE_TESTIMONIAL_COURSE,
      name:
        'Artificial Intelligence and Machine Learning: In-depth Short Course',
      image:
        'https://media.openlearning.com/pw8Bo2qGEarR9uKNCzy8pQyFDBAoyASKBvR7fEiKGeCDtB8ZvMinCTPHaH5SPcxn.1600992797/UNSW%20AI%20Hero.jpg',
      institution: 'unswshortcourses',
      courseSummary:
        "You've heard of AI, but do you understand it? Learn AI today: explore algorithms, apply machine learning, solve problems and prepare yourself for the future of work.",
      students: 86,
      path:
        'unswshortcourses/courses/artificial-intelligence-and-machine-learning-a-short-course',
      courseUrl:
        'https://www.openlearning.com/unswshortcourses/courses/artificial-intelligence-and-machine-learning-a-short-course/',
      creator: {
        'avatar@3x':
          'https://openlearning-cdn.s3.amazonaws.com/unswshortcourses-qghfxz-avatar-120-ts1599808301.jpg',
        fullName: 'UNSW Short Courses',
      },
    },
  },
  {
    name: 'Vivian Ononiwu Aliyu',
    avatar: VivianAvatar,
    cohort: 'Journey Through Data – UTS',
    description:
      '“The course made me actually think about a given piece of information and data before making my own assessment. Normally, when I go through information on the media or Internet I am wired to just take it as a matter of fact because of the supposed data attached to the information. This is interesting indeed!”',
    course: {
      ...BASE_TESTIMONIAL_COURSE,
      name: 'Journey through Data',
      image:
        'https://openlearning-cdn.s3.amazonaws.com/course__uts_courses_journeythroughdata__course-promo-image-1553734097.34.jpg',
      institution: 'uts',
      courseSummary:
        'Engage with data systematically and strategically and learn how to tell a data story.',
      students: 986,
      path: 'uts/courses/journey-through-data',
      courseUrl:
        'https://www.openlearning.com/uts/courses/journey-through-data/',
      creator: {
        'avatar@3x':
          'https://openlearning-cdn.s3.amazonaws.com/utsopen-avatar-120-ts1517791162.jpg',
        fullName: 'UTS Open',
      },
    },
  },
];
